'use client';

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import { type FC, useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { celebritiesListOptions } from '@/entities/Celebrity/api/celebritiesList';
import { NoResults } from '@/entities/Experiences';
import { CarouselCelebritiesNew } from './CarouselCelebritiesNew';
import { CarouselMobileNew } from './CarouselMobileNew';
import { CarouselNew } from './CarouselNew';
import ShowcaseContextNew from './ShowcaseContextNew';
export const ShowcaseOptimized: FC = () => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = celebritiesListOptions({
      limit: 7,
      forIndexPage: true
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: t1
  } = useSuspenseQuery(t0);
  let t2;
  if ($[1] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const celebritiesList = t2;
  const [activeIdx, setActiveIdx] = useState(0);
  const md = useMediaQuery("(min-width: 768px)");
  let t3;
  if ($[3] !== activeIdx) {
    t3 = {
      activeIdx,
      setActiveIdx
    };
    $[3] = activeIdx;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== celebritiesList || $[6] !== md) {
    t4 = <section className="bg-[#0D0C2C]"><div className="flex-col">{celebritiesList.length ? !md ? <div className="space-y-5 pb-8 md:hidden"><CarouselMobileNew celebrities={celebritiesList} /><CarouselCelebritiesNew celebrities={celebritiesList} /></div> : <div className="hidden md:block"><CarouselNew celebrities={celebritiesList}><CarouselCelebritiesNew celebrities={celebritiesList} /></CarouselNew></div> : <NoResults className="min-h-[314px]" hideNoResultsDescription={true} />}</div></section>;
    $[5] = celebritiesList;
    $[6] = md;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <ShowcaseContextNew.Provider value={t3}>{t4}</ShowcaseContextNew.Provider>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};